import { render, staticRenderFns } from "./Karin-pagination.vue?vue&type=template&id=25955c11"
import script from "./Karin-pagination.vue?vue&type=script&lang=js"
export * from "./Karin-pagination.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports